/**
 * SSOT: configurable page destination types and route patterns.
 * CommonJS so Node contract tests can require() without Babel.
 *
 * Categories:
 * - entityBrowse: fixed browse/entity routes with per-page ExperienceGate
 * - page: explicit Admin-configurable page destinations (guide, login, …)
 * - publicBrowse: dynamic /:publicSlug when PublicBrowseGate resolves Genres
 * - platform: global application entry (ExperiencePlatformGate; no page inheritance)
 */

var ENTITY_BROWSE_ROUTE_PATTERNS = [
  /^\/home$/,
  /^\/series$/,
  /^\/movies$/,
  /^\/kids$/,
  /^\/category\/[^/]+$/,
  /^\/genre\/[^/]+$/,
  /^\/film-festival$/,
  /^\/film-festival\/[^/]+$/,
  /^\/community$/,
  /^\/organization\/[^/]+$/,
  /^\/creator\/[^/]+$/,
  /^\/project\/[^/]+$/,
];

/**
 * Admin-configurable page destinations (ExperiencePresentationGateway PAGE types).
 * pathname pattern → destination_type (exact match; no pathname checks in components).
 */
var PAGE_DESTINATION_ROUTES = [
  { destinationType: "guide", pattern: /^\/guide$/ },
  { destinationType: "login", pattern: /^\/login$/ },
  { destinationType: "register", pattern: /^\/register$/ },
  { destinationType: "search", pattern: /^\/search$/ },
  { destinationType: "shop", pattern: /^\/shop$/ },
];

function normalizePathname(pathname) {
  return (
    String(pathname || "")
      .split("?")[0]
      .replace(/\/+$/, "") || "/"
  );
}

function destinationTypeForPathname(pathname) {
  var path = normalizePathname(pathname);
  var i;
  for (i = 0; i < PAGE_DESTINATION_ROUTES.length; i++) {
    if (PAGE_DESTINATION_ROUTES[i].pattern.test(path)) {
      return PAGE_DESTINATION_ROUTES[i].destinationType;
    }
  }
  return null;
}

function routeMatchesEntityBrowse(pathname) {
  var path = normalizePathname(pathname);
  return ENTITY_BROWSE_ROUTE_PATTERNS.some(function (re) {
    return re.test(path);
  });
}

module.exports = {
  ENTITY_BROWSE_ROUTE_PATTERNS: ENTITY_BROWSE_ROUTE_PATTERNS,
  PAGE_DESTINATION_ROUTES: PAGE_DESTINATION_ROUTES,
  normalizePathname: normalizePathname,
  destinationTypeForPathname: destinationTypeForPathname,
  routeMatchesEntityBrowse: routeMatchesEntityBrowse,
};
